import Vue from 'vue'

let moment = require('moment')
moment.locale('fr')

Vue.filter('date', function (date) {
  return moment(date).format('LL')
})
Vue.filter('time', function (date) {
  return moment(date).format('LT')
})

Vue.filter('datetime', function (date) {
  return moment(date).format('LLLL')
})



// WEBPACK FOOTER //
// ./src/filters/date.js